 <lib-forgot-password-confirmation
    [labels]="'lib.forgotPasswordConfirmation' | translate"

    [bank]="theme"
    [email]="email || ''"
    (resendEmail)="resendPasswordEmail(email || '')"
    (close)="closeDialog()"
  ></lib-forgot-password-confirmation>
